module.exports = __webpack_public_path__ + "img/weight4.b906ecbf.svg";